import React, {useEffect, useState} from 'react';
import moment from 'moment';
import {Row, Col} from "antd";
import 'antd/dist/antd.css';

import {GameCard} from "./components/GameCard";

export const Match = (props) => {
    const {gamesData, history} = props;
    const [games, setGames] = useState([])
    useEffect(() => {
        setGames(gamesData)
    }, [gamesData])
    return (
        <div className='match_container'>
            <Row gutter={[16, 16]}>
                <Col span={18}>
                    <h3>今日の試合一覧（LIVE）<span className='date-match'>{moment().locale('ja').format('LL(ddd)')}</span></h3>
                </Col>
                <Col span={6} className='class'>
                    <img style={{ width: '24px'}} src='/img/update24px.png'/><span className='img-time'>30秒ごとに更新</span>
                </Col>
            </Row>
            <div className='d-flex-between'>
                {
                    games.map((item, index) => {
                        return (
                            <div className='league_container' key={index}>
                                <h4 style={{marginBottom: '24px','font-size': '16px'}}>{item.league_name}</h4>
                                {
                                    item.games.map(game => <GameCard history={history} gameData={game}/>)
                                }

                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}
